import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { CreateData } from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import './budget.css';

// ── Generic SQL executor ───────────────────────────────────────────
const runQuery = async (sql) => {
  const payload = { query: sql };
  const creds = Fetchexecutequery();
  const response = await axios.post(creds[1], payload, creds[0]);
  return response.data;
};

const Tabs = () => {
  const [activeTab, setActiveTab]     = useState('1');
  const [error, setError]             = useState(null);
  const [filterconditions]            = useState([{ is_active: 1, entity_id: 1 }]);

  // ── Group (tab 1) ──────────────────────────────────────────────
  const [section4Rows, setSection4Rows] = useState([{}]);
  const [fields3, setFields3]           = useState([]);
  const [columnDefs3, setColumnDefs3]   = useState([]);
  const [gridData3, setGridData3]       = useState([]);

  // ── Entity (tab 2) ─────────────────────────────────────────────
  const [section2Rows, setSection2Rows] = useState([{}]);
  const [fields1, setFields1]           = useState([]);
  const [columnDefs1, setColumnDefs1]   = useState([]);
  const [gridData1, setGridData1]       = useState([]);
  // allocated / unallocated per group value in entity tab
  const [entityBudgetSummary, setEntityBudgetSummary] = useState([]);

  // ── Division (tab 3) ───────────────────────────────────────────
  const [section3Rows, setSection3Rows] = useState([{}]);
  const [fields2, setFields2]           = useState([]);
  const [columnDefs2, setColumnDefs2]   = useState([]);
  const [gridData2, setGridData2]       = useState([]);
  // allocated / unallocated per entity value in division tab
  const [divisionBudgetSummary, setDivisionBudgetSummary] = useState([]);

  // ── Helpers ────────────────────────────────────────────────────
  const getFieldLabel = (field) => {
    if (field.renameValue && field.renameValue.trim() !== '') return field.renameValue;
    return field.columnName.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const getFormattedDate = () =>
    new Date().toISOString().slice(0, 19).replace('T', ' ');

  const validateField = (value, type) => {
    if (!type) return true;
    switch (type.value) {
      case 'text':    return true;
      case 'integer': return /^-?\d*$/.test(value);
      case 'decimal': return /^-?\d*\.?\d*$/.test(value);
      case 'date':    return !isNaN(Date.parse(value));
      default:        return true;
    }
  };

  // ── Fetch grid data via Fetchexecutequery ──────────────────────
// ONLY showing modified parts clearly — rest of your file remains SAME

// ── FIX 1: fetchGridData ──────────────────────────────────────
const fetchGridData = async (table, setGridDataFunc) => {

  let sql = "";

  if (table === 'tier') {
    sql = `SELECT * FROM budget_planning.tier`;
  }

  else if (table === 'tier_1') {
    sql = `
      SELECT 
        t1.*,
        t.name AS group_name
      FROM budget_planning.tier_1 t1
      LEFT JOIN budget_planning.tier t 
        ON t.name = t1.tier_id
    `;
  }

  else if (table === 'tier_2') {
    sql = `
      SELECT 
        t2.*,
        t1.name AS entity_name,
        t.name AS group_name
      FROM budget_planning.tier_2 t2
      LEFT JOIN budget_planning.tier_1 t1 
        ON t1.name = t2.tier1_id
      LEFT JOIN budget_planning.tier t 
        ON t.name = t1.tier_id
    `;
  }

  try {
    const data = await runQuery(sql);
    const rows = Array.isArray(data) ? data : (data.rows || data.data || []);
    setGridDataFunc(rows);
    return rows;
  } catch (err) {
    console.error(`Error fetching grid data for ${table}:`, err);
    return [];
  }
};

  // ── Fetch budget summary for Entity tab ───────────────────────
  // Groups tier_1 rows by tier_id (= Group), sums budget_allocated
// ── FIX 2: Entity Budget Summary (Group level) ───────────────
const fetchEntityBudgetSummary = async () => {
  try {
    const sql = `
      SELECT
        t.name AS tier_id,
        t.name AS group_name,
        t.budget_allocated AS group_budget,
        COALESCE(SUM(t1.budget_allocated),0) AS total_allocated,
        (t.budget_allocated - COALESCE(SUM(t1.budget_allocated),0)) AS unallocated
      FROM budget_planning.tier t
      LEFT JOIN budget_planning.tier_1 t1
        ON t1.tier_id = t.name
      GROUP BY t.name
    `;

    const data = await runQuery(sql);
    const rows = Array.isArray(data) ? data : (data.rows || data.data || []);
    setEntityBudgetSummary(rows);
  } catch (err) {
    console.error('Error fetching entity budget summary:', err);
  }
};

  // ── Fetch budget summary for Division tab ─────────────────────
  // Groups tier_2 rows by tier1_id (= Entity), sums budget_allocated
// ── FIX 3: Division Budget Summary (Entity level) ────────────
const fetchDivisionBudgetSummary = async () => {
  try {
    const sql = `
      SELECT
        t1.name AS tier1_id,
        t1.name AS entity_name,
        t1.budget_allocated AS entity_budget,
        COALESCE(SUM(t2.budget_allocated),0) AS total_allocated,
        (t1.budget_allocated - COALESCE(SUM(t2.budget_allocated),0)) AS unallocated
      FROM budget_planning.tier_1 t1
      LEFT JOIN budget_planning.tier_2 t2
        ON t2.tier1_id = t1.name
      GROUP BY t1.name, t1.budget_allocated
    `;

    const data = await runQuery(sql);
    const rows = Array.isArray(data) ? data : (data.rows || data.data || []);
    setDivisionBudgetSummary(rows);
  } catch (err) {
    console.error('Error fetching division budget summary:', err);
  }
};

  // ── Edit handlers — load from existing grid row ────────────────
  const handleEditClick1 = (rowData) => {
    setSection2Rows([{ ...rowData, primary_id: rowData.id }]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const handleEditClick2 = (rowData) => {
    setSection3Rows([{ ...rowData, primary_id: rowData.id }]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const handleEditClick3 = (rowData) => {
    setSection4Rows([{ ...rowData, primary_id: rowData.id }]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ── Build AG Grid columns ──────────────────────────────────────
  const buildAgColumns = (fields, onEditClick) => {
    const cols = fields
      .filter((f) => f.function)
      .map((f) => ({
        headerName: getFieldLabel(f),
        field: f.columnName,
        flex: 1,
        minWidth: 120,
        resizable: true,
        sortable: true,
        filter: true,
      }));

    cols.push({
      headerName: 'Edit',
      field: 'edit',
      width: 80,
      pinned: 'right',
      sortable: false,
      filter: false,
      cellRenderer: (params) => (
        <Icon
          name="edit"
          style={{ cursor: 'pointer', color: '#1976d2' }}
          onClick={() => onEditClick(params.data)}
        />
      ),
    });

    return cols;
  };

  // ── Fetch fields from header config ───────────────────────────
  const fetchFieldInfo = async (
    headerConfigId, setFieldsFunc, setColumnDefsFunc, onEditClick
  ) => {
    const payload = { headerconfig_id: headerConfigId, filterconditions };
    try {
      const creds = Fetchheaderdata();
      const response = await axios.post(creds[1], payload, creds[0]);
      const data = response.data;
      console.log('fetched fields', data);
      if (data.fields?.length) {
        setFieldsFunc(data.fields);
        setColumnDefsFunc(buildAgColumns(data.fields, onEditClick));
      }
    } catch (err) {
      console.error(`Error fetching field info for ${headerConfigId}:`, err);
      setError('Error fetching fields data');
    }
  };

  // ── Initial load ───────────────────────────────────────────────
  useEffect(() => {
    // Fetch field configs
    fetchFieldInfo(97, setFields3, setColumnDefs3, handleEditClick3); // Group
    fetchFieldInfo(31, setFields1, setColumnDefs1, handleEditClick1); // Entity
    fetchFieldInfo(32, setFields2, setColumnDefs2, handleEditClick2); // Division

    // Fetch grid data from MySQL
    fetchGridData('tier',   setGridData3);
    fetchGridData('tier_1', setGridData1);
    fetchGridData('tier_2', setGridData2);

    // Fetch budget summaries
    fetchEntityBudgetSummary();
    fetchDivisionBudgetSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Submit ─────────────────────────────────────────────────────
  async function handleCreate() {
    try {
      await handleCreate2();
    } catch (err) {
      console.error('Error during create operations:', err);
      setError('Error during create operations');
      alert('Error during create operations. Please try again.');
    }
  }

  const handleCreate2 = async () => {
    try {
      const formattedDate = getFormattedDate();
      const updatedFormData = [];

      const rowData =
        activeTab === '1' ? section4Rows :
        activeTab === '2' ? section2Rows :
        section3Rows;

      const table =
        activeTab === '1' ? 'tier' :
        activeTab === '2' ? 'tier_1' :
        'tier_2';

      const setGridData =
        activeTab === '1' ? setGridData3 :
        activeTab === '2' ? setGridData1 :
        setGridData2;

      rowData.forEach((record) => {
        const sanitizedRecord = Object.fromEntries(
          Object.entries(record).filter(
            ([k]) => !['index', 'id', 'primary_id', 'label'].includes(k)
          )
        );

        if (record.primary_id) {
          // UPDATE via Fetchupdatequery
          const payload = {
            schema_name: 'budget_planning',
            table,
            set_column: { ...sanitizedRecord, modified_date: formattedDate },
            where: [{ id: record.primary_id }],
          };
          console.log('Update payload:', payload);
          const creds = Fetchupdatequery();
          axios.post(creds[1], payload, creds[0])
            .then(() => {
              // Update grid row in place
              setGridData((prev) =>
                prev.map((r) =>
                  r.id === record.primary_id ? { ...r, ...sanitizedRecord } : r
                )
              );
              // Refresh summaries after save
              if (activeTab === '2') fetchEntityBudgetSummary();
              if (activeTab === '3') fetchDivisionBudgetSummary();
            })
            .catch((err) => console.error('Error updating record:', err));
        } else {
          updatedFormData.push({ ...sanitizedRecord });
        }
      });

      if (updatedFormData.length > 0) {
        const payload = { database: 'budget_planning', table, formData: updatedFormData };
        const creds = CreateData();
        axios.post(creds[1], payload, creds[0])
          .then((response) => {
            const newRows = response.data?.rows || updatedFormData;
            setGridData((prev) => [...prev, ...newRows]);
            // Refresh summaries after save
            if (activeTab === '2') fetchEntityBudgetSummary();
            if (activeTab === '3') fetchDivisionBudgetSummary();
          })
          .catch((err) => {
            console.error('Error creating records:', err);
            setError('Error creating records');
          });
      }

      alert('Data Stored successfully!');
    } catch (err) {
      console.error('Error in handleCreate2:', err.message);
      setError('Error processing data');
      alert('Error processing data. Please try again.');
    }
  };

  // ── Row add / delete ───────────────────────────────────────────
  const deleteRowInSection2 = (index) => {
    if (section2Rows.length <= 1) return;
    if (!window.confirm('Are you sure you want to delete this row?')) return;
    setSection2Rows(section2Rows.filter((_, i) => i !== index));
  };
  const addRowInSection2 = () => setSection2Rows([...section2Rows, {}]);

  const deleteRowInSection3 = (index) => {
    if (section3Rows.length <= 1) return;
    if (!window.confirm('Are you sure you want to delete this row?')) return;
    setSection3Rows(section3Rows.filter((_, i) => i !== index));
  };
  const addRowInSection3 = () => setSection3Rows([...section3Rows, {}]);

  const deleteRowInSection4 = (index) => {
    if (section4Rows.length <= 1) return;
    if (!window.confirm('Are you sure you want to delete this row?')) return;
    setSection4Rows(section4Rows.filter((_, i) => i !== index));
  };
  const addRowInSection4 = () => setSection4Rows([...section4Rows, {}]);

  // ── Input change handlers ──────────────────────────────────────
  const makeInputChange = (setRows) => (name, value, index, type) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      if (!validateField(value, type)) return prevRows;
      updatedRows[index] = { ...updatedRows[index], [name]: value };
      if (name === 'quantity' || name === 'unit_value') {
        const r = updatedRows[index];
        updatedRows[index] = { ...r, total_value: r.quantity * r.unit_value };
      }
      return updatedRows;
    });
  };

  const handleInputChange1 = makeInputChange(setSection2Rows);
  const handleInputChange2 = makeInputChange(setSection3Rows);
  const handleInputChange3 = makeInputChange(setSection4Rows);

  // ── Budget summary card renderer ───────────────────────────────
  const renderBudgetSummary = (summaryRows, groupByLabel, groupByKey) => {
    if (!summaryRows || summaryRows.length === 0) return null;
    return (
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px',
        margin: '16px 20px',
      }}>
        {summaryRows.map((row, i) => {
          const allocated   = parseFloat(row.total_allocated) || 0;
          const groupBudget = parseFloat(row.group_budget || row.entity_budget) || 0;
          const unallocated = parseFloat(row.unallocated) || 0;
          const pct = groupBudget > 0 ? Math.min((allocated / groupBudget) * 100, 100) : 0;

          return (
            <div key={i} style={{
              background: '#fff',
              border: '1px solid #e0e0e0',
              borderRadius: '10px',
              padding: '14px 18px',
              minWidth: '220px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
            }}>
              <div style={{ fontSize: '12px', color: '#888', marginBottom: '4px' }}>
                {groupByLabel}
              </div>
              <div style={{ fontWeight: '700', fontSize: '15px', marginBottom: '10px', color: '#222' }}>
                {row[groupByKey] || '—'}
              </div>

              {/* Progress bar */}
              <div style={{
                height: '6px', borderRadius: '3px',
                backgroundColor: '#e0e0e0', marginBottom: '10px',
              }}>
                <div style={{
                  height: '6px', borderRadius: '3px',
                  width: `${pct}%`,
                  backgroundColor: pct > 90 ? '#e53935' : pct > 70 ? '#fb8c00' : '#43a047',
                  transition: 'width 0.4s',
                }} />
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                <div>
                  <div style={{ color: '#888', fontSize: '11px' }}>Allocated</div>
                  <div style={{ fontWeight: '600', color: '#1976d2' }}>
                    {allocated.toLocaleString()}
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ color: '#888', fontSize: '11px' }}>Unallocated</div>
                  <div style={{ fontWeight: '600', color: unallocated < 0 ? '#e53935' : '#43a047' }}>
                    {unallocated.toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  // ── Reusable form row renderer ─────────────────────────────────
  const renderFormRows = (rows, fields, handleInputChange, deleteRow, addRow) => (
    <div>
      {rows && rows.length > 0 ? rows.map((row, index) => (
        <div
          key={row.id || index}
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '10px',
            margin: '20px',
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '10px',
            border: row.primary_id ? '1px solid #1976d2' : '1px solid transparent',
          }}
        >
          {/* Blue "Editing" badge when row came from grid edit */}
          {row.primary_id && (
            <div style={{
              width: '100%',
              fontSize: '11px',
              color: '#1976d2',
              fontWeight: '600',
              marginBottom: '4px',
            }}>
              ✏️ Editing existing record (ID: {row.primary_id})
            </div>
          )}

          {fields.map((field, fieldIndex) => {
            if (!field.function) return null;
            const isDropdown = field.function === 'Dropdown';
            return (
              <div key={fieldIndex} className="form-group">
                <label className="form-label" style={{ marginLeft: '5px' }}>
                  {getFieldLabel(field)}:
                </label>
                <div className="form-input">
                  {isDropdown ? (
                    <select
                      name={field.columnName}
                      value={row[field.columnName] || ''}
                      onChange={(e) =>
                        handleInputChange(field.columnName, e.target.value, index, field.type)
                      }
                      className="form-control"
                    >
                      <option value="" disabled>
                        {`Select ${getFieldLabel(field)}`}
                      </option>
                      {field.options?.map((option, idx) => (
                        <option key={idx} value={option.value}>{option.label}</option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      name={field.columnName}
                      value={row[field.columnName] || ''}
                      onChange={(e) =>
                        handleInputChange(field.columnName, e.target.value, index, field.type)
                      }
                      className="form-control"
                    />
                  )}
                </div>
              </div>
            );
          })}

          <Icon
            name="trash"
            style={{ cursor: 'pointer', marginLeft: '10px', color: 'red' }}
            onClick={() => deleteRow(index)}
          />
          {index === rows.length - 1 && (
            <Icon
              name="plus"
              style={{ cursor: 'pointer', marginLeft: '10px', color: 'green' }}
              onClick={addRow}
            />
          )}
        </div>
      )) : null}
    </div>
  );

  // ── Reusable AG Grid ───────────────────────────────────────────
  const renderGrid = (columnDefs, rowData) => (
    <div className="ag-theme-alpine" style={{ height: 350, width: '100%', marginTop: '24px' }}>
      <AgGridReact
        columnDefs={columnDefs}
        rowData={rowData}
        defaultColDef={{ resizable: true, sortable: true, filter: true }}
        pagination={true}
        paginationPageSize={10}
        animateRows={true}
      />
    </div>
  );

  // ── Tab styles ─────────────────────────────────────────────────
  const tabBarStyle = {
    display: 'flex',
    borderBottom: '2px solid #e0e0e0',
    marginBottom: '0',
    backgroundColor: '#f5f5f5',
  };

  const tabStyle = (value) => ({
    padding: '10px 24px',
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
    backgroundColor: activeTab === value ? '#ffffff' : 'transparent',
    borderBottom: activeTab === value ? '2px solid #1976d2' : '2px solid transparent',
    color: activeTab === value ? '#1976d2' : '#555',
    fontWeight: activeTab === value ? '600' : '400',
    fontSize: '14px',
    marginBottom: '-2px',
    transition: 'all 0.2s',
  });

  // ── JSX ────────────────────────────────────────────────────────
  return (
    <div className="tabs-container">

      {/* ── Tab Bar ── */}
      <div style={tabBarStyle}>
        <button style={tabStyle('1')} onClick={() => setActiveTab('1')}>Group</button>
        <button style={tabStyle('2')} onClick={() => setActiveTab('2')}>Entity</button>
        <button style={tabStyle('3')} onClick={() => setActiveTab('3')}>Division</button>
      </div>

      {/* ── Group ── */}
      {activeTab === '1' && (
        <div className="section" id="section-group">
          {renderFormRows(
            section4Rows, fields3, handleInputChange3,
            deleteRowInSection4, addRowInSection4
          )}
          <div className="submit-row">
            <button type="button" className="submit-btn" onClick={handleCreate}>Submit</button>
          </div>
          {renderGrid(columnDefs3, gridData3)}
        </div>
      )}

      {/* ── Entity ── */}
      {activeTab === '2' && (
        <div className="section" id="section-entity">
          {renderFormRows(
            section2Rows, fields1, handleInputChange1,
            deleteRowInSection2, addRowInSection2
          )}
          <div className="submit-row">
            <button type="button" className="submit-btn" onClick={handleCreate}>Submit</button>
          </div>

          {/* Allocated / Unallocated summary cards grouped by tier_id (Group) */}
          <div style={{ margin: '8px 20px 0', fontWeight: '600', color: '#555', fontSize: '13px' }}>
            Budget Summary by Group
          </div>
        
{renderBudgetSummary(entityBudgetSummary, 'Group', 'group_name')}
          {renderGrid(columnDefs1, gridData1)}
        </div>
      )}

      {/* ── Division ── */}
      {activeTab === '3' && (
        <div className="section" id="section-division">
          {renderFormRows(
            section3Rows, fields2, handleInputChange2,
            deleteRowInSection3, addRowInSection3
          )}
          <div className="submit-row">
            <button type="button" className="submit-btn" onClick={handleCreate}>Submit</button>
          </div>

          {/* Allocated / Unallocated summary cards grouped by tier1_id (Entity) */}
          <div style={{ margin: '8px 20px 0', fontWeight: '600', color: '#555', fontSize: '13px' }}>
            Budget Summary by Entity
          </div>
{renderBudgetSummary(divisionBudgetSummary, 'Entity', 'entity_name')}

          {renderGrid(columnDefs2, gridData2)}
        </div>
      )}

    </div>
  );
};

export default Tabs;